<template>
  <div class="flex flex-wrap items-center gap-2">
    <AnalyticsDateRangePicker :modelValue="dateRange" @update:modelValue="$emit('update:dateRange', $event)" />
    <span v-if="previousPeriodStartDate" class="text-sm font-medium text-gray-400">vs</span>
    <Selector
      v-if="previousPeriodStartDate"
      id="comparison-type-selector"
      name="comparisonType"
      :modelValue="comparisonType"
      @update:modelValue="$emit('update:comparisonType', $event)"
      :options="comparisonTypeOptions"
    />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { AnalyticsDateRangePicker, Selector } from "@estaly/ui";

export default {
  components: { AnalyticsDateRangePicker, Selector },

  props: {
    dateRange: { type: Array, required: true },
    comparisonType: { type: String, required: true },
    previousPeriodStartDate: { type: String, default: null },
  },

  emits: ["update:dateRange", "update:comparisonType"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    comparisonTypeOptions() {
      return [
        { value: "previousMonth", label: this.t("comparison_previous_month") },
        { value: "previousPeriod", label: this.t("comparison_previous_period") },
        { value: "previousWeek", label: this.t("comparison_previous_week") },
        { value: "previousYear", label: this.t("comparison_previous_year") },
      ];
    },
  },
};
</script>

<i18n src="./PeriodComparisonFilter.i18n.json"></i18n>

<style scoped>
:deep(.dp__input) {
  height: 38px !important;
  min-height: 38px !important;
  font-size: 14px !important;
  border: 1px solid #d1d5db !important;
  border-radius: 0.5rem !important;
  padding: 8px 12px !important;
  line-height: 1.5 !important;
}

:deep(#comparison-type-selector) {
  font-size: 14px !important;
  height: 38px !important;
}
</style>
